<template>
  <div class="card text-center bg-white max-w-sm mx-auto p-8">
    <h1 v-text="'Add your phone number'" />
    <form
      class="form-horizontal"
      @submit.prevent="submit"
    >
      <slot name="honeypot" />
      <div class="w-full px-8 text-left">
        <div>
          <label
            for="phone_number"
            v-text="'Providing your cell number allows us to send a text message to verify your identity.'"
          />
          <VuePhoneNumberInput
            id="phone_number"
            ref="phoneNumber"
            v-model="form.phone_number"
            name="phone_number"
            color="#064bc3"
            class="mb-4"
            default-country-code="US"
            no-flags
            no-validator-state
            :disabled="Boolean(form.authCodeId)"
            @update="(payload) => (form.phone_number_country = payload.countryCode)"
          />
          <span
            v-if="form.errors.has('phone_number')"
            class="help-block"
            v-text="form.errors.get('phone_number')"
          />
        </div>
        <SecurityQuestionField
          v-model="form.security_question"
          label-classes="block text-xs mb-2"
          container-classes="select-container"
          label="Choose a Security Question"
          :error-message="form.errors.get('security_question')"
          :questions="securityQuestions.map((option) => option.question)"
        />
        <div>
          <label
            class="block text-xs mb-2"
            for="security-question-answer"
            v-text="'Provide an Answer (case-sensitive)'"
          />
          <input
            id="security-question-answer"
            v-model="form.security_answer"
            name="security-question-answer"
            :class="{ error: form.errors.has('security_answer') }"
            type="text"
            :disabled="Boolean(form.authCodeId)"
          >
          <span
            v-if="form.errors.has('security_answer')"
            class="help-block mb-1"
            v-text="form.errors.get('security_answer')"
          />
        </div>
        <Transition name="fade">
          <div v-show="form.authCodeId">
            <label
              for="auth_code"
              v-text="'Enter the verification code we just sent to the new number'"
            />
            <input
              id="auth_code"
              ref="authCode"
              v-model="form.auth_code"
              name="auth_code"
              :class="{ error: form.errors.has('auth_code') }"
              placeholder="000000"
              type="text"
              autocomplete="off"
            >
            <span
              v-if="form.errors.has('auth_code')"
              class="help-block"
              v-text="form.errors.get('auth_code')"
            />
          </div>
        </Transition>
      </div>
      <button
        type="submit"
        class="btn my-4"
        :class="{ load: form.busy }"
        v-text="'Submit'"
      />
    </form>
  </div>
</template>

<script type="text/babel">
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import MUMForm from 'Base/Resources/assets/js/MUMForm'
import SecurityQuestionField from 'Auth/Resources/assets/js/components/sms/SecurityQuestionField'

export default {
  name: 'AddPhoneNumberForm',
  components: {
    VuePhoneNumberInput,
    SecurityQuestionField,
  },
  props: {
    addPhoneNumberRoute: {
      type: String,
      required: true,
    },
    confirmVerificationCodeRoute: {
      type: String,
      required: true,
    },
    securityQuestions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: new MUMForm({
        security_question: this.securityQuestions.map(option => option.question)[0],
        phone_number: null,
        phone_number_country: '',
        security_answer: null,
        auth_code: null,
        authCodeId: null,
      }),
      potFieldName: null,
      potValidFromFieldName: null,
    }
  },
  async mounted() {
    await this.$nextTick()

    // This uses a customized version of the Spatie Honeypot to prevent spam
    this.potFieldName = document.getElementById('potFieldName').innerText

    this.potValidFromFieldName = document.getElementById('potValidFromFieldName').innerText

    this.$refs.phoneNumber.$el.getElementsByClassName('input-tel__input')[0].focus()
  },

  methods: {
    async submit() {
      this.$set(this.form, this.potFieldName, document.getElementById(this.potFieldName).value)
      this.$set(this.form, this.potValidFromFieldName, document.getElementsByName(this.potValidFromFieldName)[0].value)

      this.form.errors.clear()

      this.form.startProcessing()

      if (this.form.authCodeId) {
        try {
          const { data } = await this.$api
            .public()
            .post(this.confirmVerificationCodeRoute, this.form)

          window.location = `${data.redirect}?phone-number-added`
        } catch (errors) {
          this.form.errors.set(errors.response.data)
        } finally {
          this.form.finishProcessing()
        }
      } else {
        try {
          const { data } = await this.$api
            .public()
            .post(this.addPhoneNumberRoute, this.form)

          this.$set(this.form, 'authCodeId', data.auth_code_id)

          this.$refs.authCode.focus()
        } catch (errors) {
          this.form.errors.set(errors.response.data)
        } finally {
          this.form.finishProcessing()
        }
      }
    },
  },
}
</script>
